<template>
  <div>
    <div class="integration_header">Integrations</div>
    <div class="integration_desc">
      <img src="../../assets/img/google_chat.svg" alt="" />
      <div class="integration_desc__opt">
        <div class="integration_desc_flex">
            <div class="integration_text">Google Chat</div>
            <div class="integration_desc_url">
            <a class="integration_href" href="https://www.google.com">google.com</a>
           <img src="@/assets/img/google_url.svg" alt="">
            </div>
            <div class="integration_text_desc">
              Connect Google Chat with Replymonster and chat with your bot directly
              from Google Chat.
            </div>
        
        </div>
        <ButtonWithLoadWebsite class="integration_btn" title="Connect" />
      </div>
    </div>
  </div>
</template>
<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
export default {
  components: {
    ButtonWithLoadWebsite,
  },
};
</script>
<style scoped>
.integration_header {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  padding-bottom: 36px;
  font-weight: 700;
  line-height: 24px;
}

.integration_btn {
  padding: 11px 0;
  max-width: 174px;
  width: 100%;
}
.integration_desc {
  display: flex;
  max-width: 499px;
  gap: 8px;
  width: 100%;
  padding: 16px 44px 20px 16px;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid #d1d1d6;
  background: #fff;
}
.integration_desc_url{
    display: flex;
    gap: 4px;
    cursor: pointer;
}
.integration_href{
    color: #3056D3;
font-family: "Inter", sans-serif;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px;
}
.integration_desc__opt{
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.integration_text {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.integration_text_desc {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.integration_desc_flex {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
